
import { Vue, Options } from "vue-class-component";
import Nav from "../../components/nav/Nav.vue";
import Algorithm from "../../components/lottery/Algorithm.vue";
import LotteryTitle from "../../components/lottery/LotteryTit.vue";
import { LotteryRuleContent } from "../../hooks/LotteryRuleContent";
import { LotteryConfig } from "../../config/Lottery.conf";

@Options({
  components: { Nav, Algorithm, LotteryTitle }
})
export default class LotteryRule extends Vue {
  content: string[] = [];
  contentRed: string[] = [];
  contentBlack: string[] = [];
  description: string[] = [];
  descriptionRed: string[] = [];
  descriptionBlack: string[] = [];
  precautions: string[] = [];
  minPerson = 0;
  mounted() {
    this.minPerson = LotteryConfig.minPerson;
    this.content = LotteryRuleContent.content;
    this.contentRed = LotteryRuleContent.contentRed;
    this.contentBlack = LotteryRuleContent.contentBlack;
    this.description = LotteryRuleContent.description;
    this.descriptionRed = LotteryRuleContent.descriptionRed;
    this.descriptionRed[0] = this.descriptionRed[0].replace(
      "100",
      LotteryConfig.minPerson.toString()
    );
    this.descriptionBlack = LotteryRuleContent.descriptionBlack;
    this.precautions = LotteryRuleContent.precautions;
  }
}
